import { Injectable } from '@angular/core';
import { AlertController, Platform } from "ionic-angular";
import { NotificationService } from "./notification.service";
// onesignal import removed for web build; runtime uses window.plugins.OneSignal

@Injectable()

export class OneSignalService {

  constructor(
    public platform: Platform,
    public notificationService: NotificationService,
    public alertCtrl: AlertController
  ) {}

  setup(){
    if (!this.platform.is('cordova')) {
      return;
    }
    if (this.platform.is('android')) {
      setTimeout(() => {
        // @ts-ignore
        window.plugins.OneSignal.setAppId("72bbcd69-dd03-4a0c-b9e9-6a4716c45c84");
        // @ts-ignore
        window.plugins.OneSignal.setNotificationOpenedHandler((jsonData) => {
          console.log('setupOneSignal: notificationOpenedCallback: ' + JSON.stringify(jsonData));
          this.handleNotification(jsonData);
        });
      }, 2000);
    } else {
      this.platform.ready().then(() => {
        // @ts-ignore
        OneSignal.initialize("72bbcd69-dd03-4a0c-b9e9-6a4716c45c84");
        // @ts-ignore
        OneSignal.Notifications.addEventListener('click', (jsonData) => {
          console.log('setupOneSignal: notificationOpenedCallback: ' + JSON.stringify(jsonData));
          this.handleNotification(jsonData);
        });
      });
    }
  }

  setExternalUserId(value){
    if (!this.platform.is('cordova')) {
      return;
    }
    if (this.platform.is('android')) {
      setTimeout(() => {
      // @ts-ignore
        window.plugins.OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {
          console.log("setupOneSignal: User accepted notifications: " + accepted);
          if (accepted) {
            console.log("OneSignalService->setExternalUserId: " + value);
            // @ts-ignore
            window.plugins.OneSignal.setExternalUserId(value);
          }
        });
      }, 2000);
    } else {
      // @ts-ignore
      OneSignal.Notifications.requestPermission(false).then((accepted: boolean) => {
        console.log("setupOneSignal: User accepted notifications: " + accepted);
        if (accepted) {
          console.log("OneSignalService->setExternalUserId: " + value);
          // @ts-ignore
          OneSignal.login(value);
        }
      });
    }
  }

  handleNotification(jsonData){
    let body = jsonData.notification.body;
    let sent = jsonData.notification.additionalData.sent;
    this.notificationService.addNotification(body, sent);
    this.alertCtrl.create({
      title: 'Bericht',
      message: body,
      buttons: ['OK']
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/services/one-signal.service.ts